import Navbar from "./Navbar";
import Footer from "./Footer";
import PrivacyFirstBanner from "./PrivacyFirstBanner";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <PrivacyFirstBanner />
    <Footer />
  </div>
);

export default Layout;
